// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rin-page-top-bar-container[data-v-5c8efd58] {\n    background-color: #FBC402;\n}\n.rin-old-store-app-not-supported[data-v-5c8efd58] {\n    font-weight: 700;\n    color: black;\n}\n", ""]);
// Exports
module.exports = exports;
